// styled components
import * as S from './Footer.styles';

const Footer = () => (
  <S.Footer>
    <p>
      I have no association, nor am I receiving any monetary gain from Hasbro, Wizards of the Coast,
      or any of the bands depicted in this site. I am not claiming copyright on any of the materials
      presented here. This was just a fun side project I&apos;ve always wanted to build, so I hope
      you enjoy it!
    </p>

    <p>
      If you wish to get in touch and help me update the wording in this footer, please reach out to
      me on{' '}
      <a href='https://twitter.com/andrew_devsrc' target='_blank' rel='noopener noreferrer'>
        Twitter
      </a>
    </p>
  </S.Footer>
);

export default Footer;
